/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAconexCertification = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v13.535l-10 6.667-10-6.667V2zm-2 1.999H4v10.465l8 5.333 8-5.333zm-4.707 1.294 1.414 1.414L13.415 10l3.292 3.293-1.414 1.414L12 11.415l-3.293 3.292-1.414-1.414L10.585 10 7.293 6.707l1.414-1.414L12 8.585z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAconexCertification as AconexCertification };
